<template>
  <div class="searchTypes">
    <span>Sort by:</span>
    <button class="searchType" @click="setSortType('createdAt')">
      Sign up date
    </button>
    <button class="searchType" @click="setSortType('sessionCount')">
      Session count
    </button>
    <button class="searchType" @click="setSortType('lastOnline')">
      lastOnline
    </button>
    <button class="searchType" @click="setSortType('reverse')">Reverse</button>
  </div>
</template>

<script>
export default {
  name: "UserSortType",
  methods: {
    setSortType(type) {
      this.$emit("setSortType", type);
    },
  },
};
</script>